export default __webpack_public_path__ + "static/media/park.9526f113.JPG";